module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Warning-2-b08d732aaa877e30eafc00fb4e6ff0cb.svg";